import AppSkeleton from './app-skeleton.vue';

export default AppSkeleton;
